import { Button, Card, CardContent, H5 } from "@sellar-io/components";
import { useMediaQuery } from "usehooks-ts";
import { Icon } from "../../../../components";
import { InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";
import { Toast } from "../../../../components/toast/Toast";
import { useToast } from "../../../../components/toast/useToast.shared";
import { PAYMENT_LINK } from "../../../../constants/routes";
export const RequestedOrderPaymentLink = ({
  orderId,
  setShowPaymentLinkPreview,
}: {
  orderId: number;
  setShowPaymentLinkPreview: (set: boolean) => void;
}) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const { toast } = useToast();
  const link = `${import.meta.env.VITE_URL}${PAYMENT_LINK.href({ orderId })}`;
  const copyLink = () => {
    toast({
      placement: "bottom",
      render: () => <Toast icon={"LINK"}>Link copied!</Toast>,
    });
    navigator.clipboard.writeText(link);
  };
  return (
    <Card className="bg-white">
      <CardContent className="flex flex-col gap-2 p-4">
        {isDesktop && <H5>Payment link</H5>}
        <div className="flex flex-row gap-2">
          <InputContainer className="w-full truncate p-0 pl-3">
            <InputText
              placeholder={""}
              readOnly={true}
              value={link}
              disabled={true}
              className={"truncate"}
            />
            <Button
              type={"submit"}
              color={"secondary"}
              className={
                "border-t-none -m-3 h-full rounded-l-none border-y-0 border-r-0 border-gray-300 p-3"
              }
              onClick={() => setShowPaymentLinkPreview(true)}
            >
              <Icon size={1} icon={"EYE"} />
              {isDesktop && "Preview"}
            </Button>
          </InputContainer>
          <Button onClick={copyLink}>
            <Icon icon={"CONTENT_COPY"} />
            {isDesktop && "Copy Link"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
